/**
 * Every API call carries the selected avatar, so the server scopes the request
 * without the page ever handling a tenant id. The tenant comes from the session
 * cookie alone — a client-supplied one would be ignored.
 */
let currentAvatarId: string | null = null;

export const setAvatarId = (id: string | null) => {
  currentAvatarId = id;
};
export const getAvatarId = () => currentAvatarId;

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

export async function api<T = any>(
  path: string,
  opts: { method?: string; body?: unknown } = {},
): Promise<T> {
  const res = await fetch(path, {
    method: opts.method ?? (opts.body ? "POST" : "GET"),
    headers: {
      "Content-Type": "application/json",
      ...(currentAvatarId ? { "x-avatar-id": currentAvatarId } : {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new ApiError(res.status, data?.error ?? `request failed (${res.status})`);
  return data as T;
}

export type Me = {
  user: { id: string; email: string; role: string; displayName: string; tenantId: string };
  tenant: { id: string; name: string; slug: string; openaiProjectId?: string; hasOwnKey: boolean };
  avatar: AvatarSummary | null;
  avatars: AvatarSummary[];
};

export type AvatarSummary = {
  id: string;
  slug: string;
  name: string;
  role: string;
  responsibility: string;
  voice: string;
  model: string;
};
